<template>
    <tr
        v-if="!isBeingEdited"
        class="kgr-table__row"
    >
        <td class="kgr-table__cell">
            {{ honor.parameterValue.value }}
        </td>
        <td class="kgr-table__cell">
            {{ honor.on }}
        </td>
        <td class="kgr-table__cell kgr-table__cell--actions">
            <button
                v-if="isEditable"
                type="button"
                class="kgr-table__action"
                @click="$emit('edit')"
            >
                <kgr-icon-edit :size="15" />
            </button>
            <button
                v-if="isDeletable"
                type="button"
                class="kgr-table__action"
                @click="$emit('remove')"
            >
                <kgr-icon-delete />
            </button>
        </td>
    </tr>
</template>

<script>
import IconDelete from '../../common/icon/IconDelete';
import IconEdit from '../../common/icon/IconEdit';
import MemberHonor from '../../../js/dto/MemberHonor';

export default {
    components: {
        'kgr-icon-edit': IconEdit,
        'kgr-icon-delete': IconDelete,
    },
    props: {
        honor: {
            type: MemberHonor,
            required: true,
        },
        editHonors: {
            type: Array,
            required: true,
        },
        isEditable: {
            type: Boolean,
            required: true,
        },
        isDeletable: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        isBeingEdited() {
            return this.editHonors.map((editHonor) => editHonor.id).indexOf(this.honor.id) !== -1;
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .notice {
    white-space: pre-line;
}

.kgr-table__cell {
    vertical-align: top;
}
</style>
